var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveSize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6668",
    "data-name": "Group 6668",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.096,
    height: 32.096,
    viewBox: "0 0 32.096 32.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6669",
    "data-name": "Group 6669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6909",
    "data-name": "Path 6909",
    d: "M151.94,303.881h11.284a.94.94,0,1,0,0-1.881H151.94a.94.94,0,0,0,0,1.881Z",
    transform: "translate(-141.534 -283.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6910",
    "data-name": "Path 6910",
    d: "M151.94,363.881h11.284a.94.94,0,1,0,0-1.881H151.94a.94.94,0,0,0,0,1.881Z",
    transform: "translate(-141.534 -339.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6911",
    "data-name": "Path 6911",
    d: "M31.82,5.29,26.805.275A.94.94,0,0,0,26.14,0H.94A.94.94,0,0,0,0,.94V31.155a.94.94,0,0,0,.94.94H31.155a.94.94,0,0,0,.94-.94V5.955A.94.94,0,0,0,31.82,5.29ZM7.585,1.881H20.749V8.149H7.585ZM24.511,30.215H7.585V17.051H24.511Zm5.7,0H26.391v-14.1a.94.94,0,0,0-.94-.94H6.645a.94.94,0,0,0-.94.94v14.1H1.881V1.881H5.7V9.09a.94.94,0,0,0,.94.94H21.69a.94.94,0,0,0,.94-.94V1.881h3.121l4.464,4.464Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6912",
    "data-name": "Path 6912",
    d: "M151.94,423.881h11.284a.94.94,0,1,0,0-1.881H151.94a.94.94,0,0,0,0,1.881Z",
    transform: "translate(-141.534 -395.546)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveSize);
export default __webpack_public_path__ + "static/media/saveSize.fd0d6d8d17d53aa0562d018301808465.svg";
export { ForwardRef as ReactComponent };